import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-medclass-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './medclass-button.component.html',
  styleUrl: './medclass-button.component.css'
})
export class MedclassButtonComponent {
  @Input() label: string = '';
  @Input() size: string = '';
  @Input() type: string = '';
  @Input() picto: string = '';
  @Input() disabled: boolean = false
  @Input() active: boolean = false;
  @Input() pressed: boolean | null = null;
  @Input() waitMode: boolean = false;
  @Input() fixedWidth: boolean = false;
  @Input() fullWidth: boolean = false;


}
